import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";

type Props = {
    isEditMode: boolean;
    withLabels?: boolean;
    className?: string;
    onAcceptClickFn: (e: any) => void;
    onCancelClickFn: (e: any) => void;
    disableAccept?: boolean;
    hideCancel?: boolean;
};

export const OwAcceptCancelActions = (props: Props) => {
    return (
        <div className={"OwAcceptCancelActions " + props.className || ""}>
            {!props.isEditMode ? (
                <div>
                    <ButtonGroup>
                        <Button variant={"success"} size={"sm"} onClick={props.onAcceptClickFn} disabled={props.disableAccept}>
                            <i className={"fas fa-check"}></i>
                            {props.withLabels ? " Accept" : ""}
                        </Button>
                        {props.hideCancel ? null : (
                            <Button variant={"danger"} size={"sm"} onClick={props.onCancelClickFn}>
                                <i className={"fas fa-times"}></i>
                                {props.withLabels ? " Cancel" : ""}
                            </Button>
                        )}
                    </ButtonGroup>
                </div>
            ) : null}
        </div>
    );
};
